import type { Chat } from './chat.types';

import { createContext } from 'react';

export const ChatContext = createContext<Chat>({
  user: undefined,
  messages: [],
  connected: false,
  connectedAt: 0,
  connecting: false,
  providerError: undefined,
  userActionError: undefined,
  sendingMessage: false,
  editingMessage: false,
  deletingMessage: false,
  actions: [],
  unreadCount: 0,
  hasNewMessages: false,
  readRepliesIds: [],
  latestUnreadModeratorReply: undefined,
  isReplyUnread: () => false,
  setModeratorReplies: () => {},
  setReadRepliesIds: () => {},
  setHasNewMessages: () => {},
  connectUser: () => {},
  connectModerator: () => {},
  sendMessage: () => Promise.resolve(true),
  sendThreadMessage: () => Promise.resolve(undefined),
  editMessage: () => Promise.resolve(true),
  deleteMessage: () => Promise.resolve(true),
  approveMessage: () => Promise.resolve(true),
  declineMessage: () => Promise.resolve(true),
  answerMessage: () => Promise.resolve(true),
  unanswerMessage: () => Promise.resolve(true),
  reactToMessage: () => {},
  getReactionsByMessageId: () => ({
    heart: [],
    thumbsUp: [],
    laugh: [],
  }),
  getNumberOfReactionsByMessageId: () => 0,
  hasUserReactedToMessage: () => false,
  voteForMessage: () => {},
  getVotesByMessageId: () => 0,
  hasUserVotedForMessage: () => false,
  disconnectChat: () => {},
});
